import React from 'react';
import PriceBenchmarking from '@/pages/PriceBenchmarking';
import Overview from '@/pages/price-benchmarking/Overview';
import Benchmark from '@/pages/price-benchmarking/Benchmark';
import FarmPrices from '@/pages/price-benchmarking/FarmPrices';
import DistributionCenter from '@/pages/price-benchmarking/DistributionCenter';
import LocalShops from '@/pages/price-benchmarking/LocalShops';
import SundayMarket from '@/pages/price-benchmarking/SundayMarket';
import Supermarket from '@/pages/price-benchmarking/Supermarket';
import Ecommerce from '@/pages/price-benchmarking/Ecommerce';
import B2BProducts from '@/pages/price-benchmarking/B2BProducts';
import MultiProductComparison from '@/pages/price-benchmarking/MultiProductComparison';
import ChipChipSalesData from '@/pages/ChipChipSalesData';
import ChipChipAcceptedDaily from '@/pages/ChipChipAcceptedDaily';
import RankingsDistributionCenter from '@/pages/price-benchmarking/RankingsDistributionCenter';
import RankingsSupermarket from '@/pages/price-benchmarking/RankingsSupermarket';
import RankingsOverall from '@/pages/price-benchmarking/RankingsOverall';
import RankingsConsistency from '@/pages/price-benchmarking/RankingsConsistency';
import RankingsVolume from '@/pages/price-benchmarking/RankingsVolume';
import B2BSalesData from '@/pages/B2BSalesData';
import B2BCreditCollections from '@/pages/B2BCreditCollections';
import ZarelyReport from '@/pages/ZarelyReport';
import DataEntry from '@/pages/price-benchmarking/DataEntry';
import Report from '@/pages/price-benchmarking/Report';

export const priceBenchmarkingRoutes = [
  { path: "price-benchmarking", element: <PriceBenchmarking /> },
  { path: "price-benchmarking/overview", element: <Overview /> },
  { path: "price-benchmarking/benchmark", element: <Benchmark /> },
  { path: "price-benchmarking/farm-prices", element: <FarmPrices /> },
  { path: "price-benchmarking/distribution-center", element: <DistributionCenter /> },
  { path: "price-benchmarking/local-shops", element: <LocalShops /> },
  { path: "price-benchmarking/sunday-market", element: <SundayMarket /> },
  { path: "price-benchmarking/supermarket", element: <Supermarket /> },
  { path: "price-benchmarking/ecommerce", element: <Ecommerce /> },
  { path: "price-benchmarking/b2b-products", element: <B2BProducts /> },
  { path: "price-benchmarking/multi-product-comparison", element: <MultiProductComparison /> },
  { path: "price-benchmarking/chipchip-sales-data", element: <ChipChipSalesData /> },
  { path: "price-benchmarking/chipchip-accepted-daily", element: <ChipChipAcceptedDaily /> },
  { path: "price-benchmarking/rankings-distribution-center", element: <RankingsDistributionCenter /> },
  { path: "price-benchmarking/rankings-supermarket", element: <RankingsSupermarket /> },
  { path: "price-benchmarking/rankings-overall", element: <RankingsOverall /> },
  { path: "price-benchmarking/rankings-consistency", element: <RankingsConsistency /> },
  { path: "price-benchmarking/rankings-volume", element: <RankingsVolume /> },
  { path: "price-benchmarking/b2b-sales-data", element: <B2BSalesData /> },
  { path: "price-benchmarking/b2b-credit-collections", element: <B2BCreditCollections /> },
  { path: "price-benchmarking/zarely-report", element: <ZarelyReport /> },
  { path: "price-benchmarking/data-entry", element: <DataEntry /> },
  { path: "price-benchmarking/report", element: <Report /> },
];
